import * as React from 'react';

import { ICommercialSpecialtySchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { Manufacture, Office, TradeArea, Warehouse } from '../icons';

export interface ISpecialtyIcon {
  icon?: React.FunctionComponent;
  title?: string;
}

export interface ISpecialtyView {
  specialtiesIcon?: ISpecialtyIcon[];
  specialtiesString?: string;
}

export const TOP_SPECIALTIES = [7026, 7113, 7128, 7104];

export const TOP_SPECIALTIES_ICONS = new Map<number, React.FunctionComponent>([
  [7026, Office],
  [7113, Warehouse],
  [7128, TradeArea],
  [7104, Manufacture],
]);

export function getSpecialties(specialty: ICommercialSpecialtySchema | null): ISpecialtyView {
  const defaultResult = {} as ISpecialtyView;
  /**
   * Если в указано что этот ПСН под автосервис, общепит или бытовые услуги,
   * то это выводится в заголовке, тут в описании вывод "Возможное назначение:..." скрывается
   */
  if (
    specialty &&
    Array.isArray(specialty.types) &&
    specialty.types.length === 1 &&
    ['carService', 'publicCatering', 'domesticServices'].includes(specialty.types[0])
  ) {
    return defaultResult;
  }

  if (specialty) {
    const { specialties } = specialty;

    if (specialties) {
      const specialtiesIcon = TOP_SPECIALTIES.reduce((accumulator, topSpecialty) => {
        const specialty = specialties.find(specialty => specialty.id === topSpecialty);

        if (specialty?.id && specialty.rusName) {
          accumulator.push({
            title: specialty.rusName,
            icon: TOP_SPECIALTIES_ICONS.get(specialty.id),
          });
        }

        return accumulator;
      }, Array.of<ISpecialtyIcon>());

      const specialtiesString = specialties
        .reduce((accumulator, specialty) => {
          if (specialty.id && !TOP_SPECIALTIES.includes(specialty.id) && specialty.rusName) {
            accumulator.push(specialty.rusName.toLowerCase());
          }

          return accumulator;
        }, Array.of<string>())
        .join(', ');

      return {
        specialtiesIcon,
        specialtiesString,
      };
    }

    return defaultResult;
  }

  return defaultResult;
}
